import React, { useEffect } from "react";
import { DashboardTableSection } from "./DashboardTableSection";
import { gdprColumns, documentColumns } from "./tableConfig";
import { usePendingTasks } from "../../hooks/usePendingTasks";

interface PendingTasksTabProps {
  pendingSubTab: "gdpr" | "documents";
  setPendingSubTab: (subTab: "gdpr" | "documents") => void;
  onCountLoad?: (count: number) => void;
}

export const PendingTasksTab: React.FC<PendingTasksTabProps> = ({ 
  pendingSubTab, 
  setPendingSubTab,
  onCountLoad
}) => {
  const { gdprNoConsentList = [], documentsWithNoFileList = [], isLoading } = usePendingTasks();

  const data = pendingSubTab === "gdpr" ? gdprNoConsentList : documentsWithNoFileList;
  const columns = pendingSubTab === "gdpr" ? gdprColumns : documentColumns;

  const totalPending = gdprNoConsentList.length + documentsWithNoFileList.length;

  useEffect(() => {
    if (onCountLoad) {
      onCountLoad(totalPending);
    }
  }, [totalPending, onCountLoad]);

  return (
    <DashboardTableSection
      activeTab="pending"
      pendingSubTab={pendingSubTab}
      setPendingSubTab={setPendingSubTab}
      data={data}
      columns={columns}
      loading={isLoading}
      gdprLength={gdprNoConsentList.length}
      documentsLength={documentsWithNoFileList.length}
    />
  );
};